<script>
export default {
  name: "BenefitBox",
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    image: {
      type: String,
    },
    imagePosition: {
      type: String,
    },
  }
}
</script>

<template>
    <article
        class="h-100"
        :class="{ 'pb-3': imagePosition === 'top', 'pt-2': imagePosition === 'bottom' }"
    >
        <div class="d-flex flex-column text-center">
            <img
                :src="image"
                :alt="title"
                class="img-fluid"
                loading="lazy"
                decoding="async"
                :class="{
                    'mb-1': imagePosition === 'top',
                    'mt-1 order-2': imagePosition === 'bottom'
                }"
            />

            <div class="px-2" :class="{ 'order-1': imagePosition === 'bottom' }">
                <h3 class="beta">{{ title }}</h3>
                <p>{{ description }}</p>
            </div>
        </div>
    </article>
</template>

<style lang="scss" scoped>
article {
    background-color: var(--global-color-white);
    border-radius: 1.6rem;
    overflow: hidden;
}

h3 {
    font-weight: var(--font-weight-semibold);
    margin-bottom: 0.7rem;
}
</style>
